import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=68b0d2ea&scoped=true&"
import script from "./client-list.vue?vue&type=script&lang=ts&"
export * from "./client-list.vue?vue&type=script&lang=ts&"
import style0 from "./client-list.vue?vue&type=style&index=0&id=68b0d2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0d2ea",
  null
  
)

component.options.__file = "client-list.vue"
export default component.exports